/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoBcgVaccination =
  (typeof TuberculosisHistoryDtoBcgVaccination)[keyof typeof TuberculosisHistoryDtoBcgVaccination];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoBcgVaccination = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
